import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/index",
  },
  {
    path: '/index',
    component: () => import('../views/index/index.vue'),
    meta: {
      name: "首页",
      title: "首页",
    },
  },
  {
    path: "/globalGrowthLink",
    component: () => import("../views/globalGrowthLink/index.vue"),
    meta: {
      name: "全域增长链路",
      title: "全域增长链路",
    },
  },
  {
    path: "/intelligentEcologicalMatrix",
    component: () => import("../views/intelligentEcologicalMatrix/index.vue"),
    meta: {
      name: "智能生态矩阵",
      title: "智能生态矩阵",
    },
  },
  {
    path: "/chineseDigitalHuman",
    component: () => import("../views/intelligentEcologicalMatrix/chineseDigitalHuman.vue"),
    meta: {
      name: "智能中医数字人体",
      title: "智能生态矩阵",
    },
  },
  {
    path: "/moveDigitalHuman",
    component: () => import("../views/intelligentEcologicalMatrix/moveDigitalHuman.vue"),
    meta: {
      name: "移动数字人",
      title: "智能生态矩阵",
    },
  },
  {
    path: "/brandValueNarrative",
    component: () => import("../views/brandValueNarrative/index.vue"),
    meta: {
      name: "品牌价值叙事",
      title: "品牌价值叙事",
    },
  },
  {
    path: "/intelligentDrivingEngine",
    component: () => import("../views/intelligentDrivingEngine/index.vue"),
    meta: {
      name: "数智驱动引擎",
      title: "数智驱动引擎",
    },
  },
  {
    path: "/joinUs",
    component: () => import("../views/joinUs/index.vue"),
    meta: {
      name: "加入我们",
      title: "加入我们",
    },
  },
  {
    path: "/contactUs",
    component: () => import("../views/contactUs/index.vue"),
    meta: {
      name: "联系我们",
      title: "联系我们",
    },
  },
  {
    path: "/numIntelligenceEngineDs",
    component: () => import("../views/numIntelligenceEngineDs/index.vue"),
    meta: {
      name: "数智驱动引擎详情",
      title: "数智驱动引擎详情",
    },
  },




  {
		path: "/pageNotFound",
		name: "pageNotFound",
		component: () => import("../views/page-not-found/pagenotfound.vue"),
	},
	{
		path: "*",
		redirect: "/pageNotFound",
		name: "notFound",
		hidden: true,
	},
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0,
			};
		}
	},
})

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error);
};

export default router